import { translate, type Params } from "./translate.ts";
import type { Locale } from "./config.ts";

/**
 * API errors are "CODE: human readable detail" (services) or "CODE" (routes). The UI never shows the
 * English detail: it looks up `errors.<CODE>` in the active language. Unknown codes fall back to
 * `errors.UNKNOWN`.
 */
export function extractErrorCode(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const m = raw.trim().match(/^([A-Z][A-Z0-9_]{2,})(?::|$)/);
  return m ? m[1] : null;
}

export function localizeError(locale: Locale, raw: unknown, params?: Params): string {
  const code = extractErrorCode(raw);
  if (code) {
    const key = `errors.${code}`;
    const msg = translate(locale, key, params);
    if (msg !== key) return msg;
  }
  return translate(locale, "errors.UNKNOWN", params);
}
